import ControlProps from '../../../mixins/ControlProps';
import { RatingItemPropertyType } from '../enums';
import { IconType } from '../../../../../icon/enums';
import { StyleColorSchemeType, StyleSizeType } from '../../../../../../styles/enums';

const RatingItemProps = {
  props: {
    ...ControlProps.props,
    [RatingItemPropertyType.Name]: {
      type: String,
      required: true,
    },
    [RatingItemPropertyType.CheckedIcon]: {
      type: String,
      default: IconType.StarFilled,
    },
    [RatingItemPropertyType.UncheckedIcon]: {
      type: String,
      default: IconType.StarOutlined,
    },
    [RatingItemPropertyType.Size]: {
      type: String,
      default: StyleSizeType.Small,
    },
    [RatingItemPropertyType.ColorScheme]: {
      type: String,
      default: StyleColorSchemeType.Secondary,
    },
  },
};

export default RatingItemProps;
